import React, { useEffect } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { handleError, handleSuccess } from '../../helpers/utils';
import { Stack } from '@mui/system';
import { useLocation, useNavigate } from 'react-router';
import { registerProvider, updateProvider } from '../../actions/provider';

export const ProviderForm = ({ edit = false, readOnly = false }) => {
	// URL params
	const location = useLocation();
	const { providerData } = location.state || {};

	// Define state to know if it's loading or not
	const [isLoading, setIsLoading] = useState(false);

	// Form
	const [provider, setProvider] = useState({
		name: '',
		phone_number: '',
		email: '',
		address: '',
		website: '',
		description: '',
		services: '',
	});

	// Navigation
	const navigate = useNavigate();

	// Go to path
	const goToProvidersTable = () => {
		const path = `/dashboard/proveedores`;
		localStorage.setItem('currentPathPilu', path);
		navigate(path);
	};

	// Handle submit
	const handleSubmit = () => {
		// Set loading state to true
		setIsLoading(true);

		if (edit) {
			// Update order
			updateProvider(provider?.id, provider)
				.then(() => {
					// Feedback success
					handleSuccess('Proveedor actualizado correctamente.');
				})
				.catch((error) => {
					handleError(error, 'No se pudo actualizar el proveedor.');
				});
		} else {
			// Register new order
			registerProvider(provider)
				.then(() => {
					// Feedback success
					handleSuccess('Proveedor agregado correctamente.');
				})
				.catch((error) => {
					handleError(error, 'No se pudo agregar el proveedor.');
				});
		}

		// Remove loading state
		setIsLoading(false);

		// Go to providers table
		goToProvidersTable();
	};

	useEffect(() => {
		if (edit || readOnly) {
			setProvider(providerData);
		}
	}, []);

	return (
		<div style={{ padding: '25px' }}>
			<Stack
				direction='column'
				alignItems='flex-start'
				justifyContent='space-between'
				style={{
					border: '1px solid white',
					padding: '20px 20px 0 0',
					margin: '0 0 10px 0',
					width: '100%',
				}}
			>
				<Typography variant='h4' gutterBottom>
					Nuevo proveedor
				</Typography>
				<Typography variant='p' gutterBottom>
					Complete el formulario para{' '}
					{edit ? 'editar al' : 'agregar un nuevo'} proveedor
				</Typography>
			</Stack>
			<hr />
			<Grid container spacing={2} className='mt-2'>
				<Grid item xs={4}>
					<TextField
						disabled={readOnly}
						required
						fullWidth
						label='Nombre'
						value={provider?.name}
						onChange={({ target }) =>
							setProvider({ ...provider, name: target.value })
						}
					/>
				</Grid>
				<Grid item xs={4}>
					<TextField
						disabled={readOnly}
						required
						fullWidth
						label='Número telefónico'
						value={provider?.phone_number}
						onChange={({ target }) =>
							setProvider({
								...provider,
								phone_number: target.value,
							})
						}
					/>
				</Grid>

				<Grid item xs={4}>
					<TextField
						disabled={readOnly}
						required
						fullWidth
						label='Correo Electrónico'
						value={provider?.email}
						onChange={({ target }) =>
							setProvider({ ...provider, email: target.value })
						}
					/>
				</Grid>
				<Grid item xs={4}>
					<TextField
						disabled={readOnly}
						fullWidth
						required
						label='Dirección'
						value={provider?.address}
						onChange={({ target }) =>
							setProvider({ ...provider, address: target.value })
						}
					/>
				</Grid>
				<Grid item xs={4}>
					<TextField
						disabled={readOnly}
						fullWidth
						label='Página web'
						value={provider?.website}
						onChange={({ target }) =>
							setProvider({ ...provider, website: target.value })
						}
					/>
				</Grid>

				<Grid item xs={6}>
					Descripción
					<TextField
						disabled={readOnly}
						style={{ margin: '5px 0 0 0' }}
						fullWidth
						margin='normal'
						placeholder='Descripción'
						multiline
						rows={3}
						value={provider?.description}
						onChange={({ target }) =>
							setProvider({
								...provider,
								description: target.value,
							})
						}
					/>
				</Grid>

				<Grid item xs={6}>
					Servicios
					<TextField
						disabled={readOnly}
						style={{ margin: '5px 0 0 0' }}
						fullWidth
						margin='normal'
						placeholder='Servicios'
						multiline
						rows={3}
						value={provider?.services}
						onChange={({ target }) =>
							setProvider({ ...provider, services: target.value })
						}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={2} className='mt-2'>
				<Grid item xs={6}>
					<LoadingButton
						fullWidth
						size='large'
						color='error'
						onClick={goToProvidersTable}
						variant='contained'
						loading={false}
					>
						{readOnly ? 'Salir' : 'Cancelar'}
					</LoadingButton>
				</Grid>

				<Grid item xs={6}>
					<LoadingButton
						fullWidth
						size='large'
						variant='contained'
						loading={isLoading}
						style={{ backgroundColor: '#143f6c' }}
						onClick={() => {
							if (readOnly) {
								navigate('/dashboard/editar-proveedor', {
									state: { providerData },
								});
							} else {
								handleSubmit();
							}
						}}
					>
						{edit ? 'Actualizar' : readOnly ? 'Editar' : 'Guardar'}
					</LoadingButton>
				</Grid>
			</Grid>
		</div>
	);
};
